import { RESOURCE_TASK_COLORS } from "@/data/schedularColors";
import isHoursUnconfirmed from "@/helpers/project/isHoursUnconfirmed";
import { StringHelper } from "@bryntum/schedulerpro";
import moment from "moment";
/**
 * Configuration for the scheduler
 */
/**
 * Configuration for the scheduler
 */

// Tooltip for add client buttons (plain divs)
//<i class="duration b-fa b-fa-clock" data-btip="Total task duration 8 days" role="presentation">8</i>
function plusSvg() {
  return `
  
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M9.23077 1.23077C9.23077 0.55 8.68077 0 8 0C7.31923 0 6.76923 0.55 6.76923 1.23077V6.76923H1.23077C0.55 6.76923 0 7.31923 0 8C0 8.68077 0.55 9.23077 1.23077 9.23077H6.76923V14.7692C6.76923 15.45 7.31923 16 8 16C8.68077 16 9.23077 15.45 9.23077 14.7692V9.23077H14.7692C15.45 9.23077 16 8.68077 16 8C16 7.31923 15.45 6.76923 14.7692 6.76923H9.23077V1.23077Z" fill="#717986"/>
  </svg>
  `;
}
function missingResourceTooltip(classs = "b-add-activity") {
  // #8D52EE
  return `
                      <span  data-btip="Missing Resource"  class="${`b-missing-contractor cursor-pointer ${classs}`}">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12.4997 11.6666C10.2747 11.6666 5.83301 12.7749 5.83301 14.9999V16.6666H19.1663V14.9999C19.1663 12.7749 14.7247 11.6666 12.4997 11.6666ZM4.99967 8.33325V5.83325H3.33301V8.33325H0.833008V9.99992H3.33301V12.4999H4.99967V9.99992H7.49967V8.33325M12.4997 9.99992C13.3837 9.99992 14.2316 9.64873 14.8567 9.02361C15.4818 8.39849 15.833 7.55064 15.833 6.66659C15.833 5.78253 15.4818 4.93468 14.8567 4.30956C14.2316 3.68444 13.3837 3.33325 12.4997 3.33325C11.6156 3.33325 10.7678 3.68444 10.1427 4.30956C9.51753 4.93468 9.16634 5.78253 9.16634 6.66659C9.16634 7.55064 9.51753 8.39849 10.1427 9.02361C10.7678 9.64873 11.6156 9.99992 12.4997 9.99992Z" 
              fill="${RESOURCE_TASK_COLORS.ICON2}"
              />
              </svg>
            </span>
  
  `;
}

function missingManagerTooltip() {
  // #FE8E3C
  return `
        

             <span data-btip="Missing Manager" class="b-missing-manager cursor-pointer" data-btip="Missing Resource">
                  <svg xmlns="http://www.w3.org/2000/svg"  width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M12.5 3C14.2956 3 15.75 4.39222 15.75 6.11111C15.75 7.83 14.2956 9.22222 12.5 9.22222C10.7044 9.22222 9.25 7.83 9.25 6.11111C9.25 4.39222 10.7044 3 12.5 3ZM15.75 11.1978C15.75 12.0222 15.5225 13.9433 13.9706 16.09L13.3125 12.3333L14.0763 10.8711C13.5725 10.8167 13.0444 10.7778 12.5 10.7778C11.9556 10.7778 11.4275 10.8167 10.9238 10.8711L11.6875 12.3333L11.0294 16.09C9.4775 13.9433 9.25 12.0222 9.25 11.1978C7.30812 11.7422 6 12.7222 6 13.8889V17H19V13.8889C19 12.7222 17.7 11.7422 15.75 11.1978Z" 
                    fill="${RESOURCE_TASK_COLORS.ICON2}"
                    />
                    <g clip-path="url(#clip0_47_3731)">
                    <path d="M15.833 13.8335C13.608 13.8335 9.16634 14.9418 9.16634 17.1668H5.83301H19.1663V15.5002C19.1663 13.2752 18.058 13.8335 15.833 13.8335ZM4.99967 8.8335V6.3335H3.33301V8.8335H0.833008V10.5002H3.33301V13.0002H4.99967V10.5002H7.49967V8.8335M12.4997 10.5002C13.3837 10.5002 14.2316 10.149 14.8567 9.52385C15.4818 8.89873 15.833 8.05088 15.833 7.16683C15.833 6.28277 15.4818 5.43493 14.8567 4.80981C14.2316 4.18469 13.3837 3.8335 12.4997 3.8335C11.6156 3.8335 10.7678 4.18469 10.1427 4.80981C9.51753 5.43493 9.16634 6.28277 9.16634 7.16683C9.16634 8.05088 9.51753 8.89873 10.1427 9.52385C10.7678 10.149 11.6156 10.5002 12.4997 10.5002Z" 
                    fill="${RESOURCE_TASK_COLORS.ICON2}"
                    />
                    </g>
                    <defs>
                    <clipPath id="clip0_47_3731">
                    <rect width="8" height="8" fill="white" transform="translate(0 6)"/>
                    </clipPath>
                    </defs>
                  </svg>
                  </span>
  
  `;
}

function renderMissingIcons(missingResource, missingManager) {
  // return ''
  if (!missingResource && !missingManager) {
    return "";
  }
  return `
    <span class="flex gap-1 ml-1">
 ${missingResource ? missingResourceTooltip() : ""}
      ${missingManager ? missingManagerTooltip() : ""}
    </span>
  `;
}
function infoSvg() {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM6.75 10.5H7.5V8.5H6.75C6.33437 8.5 6 8.16562 6 7.75C6 7.33437 6.33437 7 6.75 7H8.25C8.66562 7 9 7.33437 9 7.75V10.5H9.25C9.66562 10.5 10 10.8344 10 11.25C10 11.6656 9.66562 12 9.25 12H6.75C6.33437 12 6 11.6656 6 11.25C6 10.8344 6.33437 10.5 6.75 10.5ZM8 4C8.26522 4 8.51957 4.10536 8.70711 4.29289C8.89464 4.48043 9 4.73478 9 5C9 5.26522 8.89464 5.51957 8.70711 5.70711C8.51957 5.89464 8.26522 6 8 6C7.73478 6 7.48043 5.89464 7.29289 5.70711C7.10536 5.51957 7 5.26522 7 5C7 4.73478 7.10536 4.48043 7.29289 4.29289C7.48043 4.10536 7.73478 4 8 4Z" fill="#717986"/>
  </svg>`;
}
/// percentage to tailwind color shade
// @params: percentage: number ( 0 - 100)
// return gray-100 to gray-900
function getShadeColor(percentage) {
  const shade = Math.floor((percentage / 100) * 9);
  return `${shade}00`;
}
const milisinfifteendays = 24 * 60 * 60 * 1000 * 15;
const currentDate = new Date();
currentDate.setHours(0, 0, 0, 0);
const minus15days = currentDate.getTime() - milisinfifteendays;
const newUPdatedDate = new Date(minus15days);
newUPdatedDate.setHours(0, 0, 0, 0);

// Calculate the date 4 weeks from now
const fourWeeksFromNow = new Date(currentDate);
fourWeeksFromNow.setDate(currentDate.getDate() + 8); //

// <span class="flex absolute top-0 right-2">
// ${
//   record.missingContractor
//     ? missingContractorTooltip()
//     : ""
// }
// ${record.missingManager ? missingManagerTooltip() : ""}
// </span>
const schedulerConfig = {
  startDate: newUPdatedDate, // Start from Jan 1, 2023
  // endDate: fourWeeksFromNow, // Set your desired end date (7 days after start date)

  // viewPreset: "weekAndDay",
  viewPreset: {
    // tickWidth: 30,
    // zoomToLevel: 0,

    base: "weekAndDay",
    // displayDateFormat: "h:mm", // Controls how dates will be displayed in tooltips etc
    // shiftIncrement: 15, // Controls how much time to skip when calling shiftNext and shiftPrevious.
    // shiftUnit: "minute", // Valid values are 'millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'.
    defaultSpan: 30, // By default, if no end date is supplied to a view it will show 12 days
    timeResolution: {
      // Dates will be snapped to this resolution
      unit: "day", // Valid values are 'millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'.
      increment: 1,
    },
    // headers: [
    //   {
    //     unit: "hour",
    //     dateFormat: "a",
    //   },
    //   {
    //     unit: "minute",
    //     increment: 15,
    //     dateFormat: "h:mm",
    //   },
    // ],
  },
  // forceFit: true,
  rowHeight: 80,
  barMargin: 5,
  multiEventSelect: false,
  cellEditFeature: false,
  treeFeature: true,
  scheduleContextMenuFeature: false,
  eventContextMenuFeature: false,
  eventEditFeature: false,
  eventDragFeature: false,
  eventResizeFeature: true,
  eventTooltipFeature: {
    // Enable the event tooltip feature
    disabled: false,

    // Adjust alignment and positioning
    align: "b-t",
    axisLocked: true,

    // Custom tooltip template
    template: ({ eventRecord, resourceRecord }) => {
      const data = eventRecord.data || {};
      const entityInfo = data.entityInfo || {};
      const isProject = data.type === "project";
      const isActivity = data.type === "activity";

      // Different tooltip structure for projects vs activities
      if (isProject) {
        const project = entityInfo.project || {};
        const manager = project.manager || {};
        const managerName = manager.name || "N/A";

        return `
          <div class="custom-tooltip project-tooltip">
            <div class="tooltip-header">
              <h2>${project.name || data.name || "Project"}</h2>
              <div class="tooltip-scheduled">Scheduled visits: ${
                project.project_activities.length || 0
              }</div>
            </div>
            <div class="tooltip-manager">
              <div class="tooltip-manager-wrap">
                <div class="manager-avatar">
                  <img src="${
                    manager.avatar || ""
                  }" onerror="this.src='data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2240%22 height=%2240%22><rect width=%2240%22 height=%2240%22 rx=%2220%22 fill=%22%23ccc%22/><text x=%2220%22 y=%2225%22 font-size=%2220%22 text-anchor=%22middle%22 fill=%22white%22>${managerName.charAt(
          0
        )}</text></svg>'">
                </div>
                <div>${managerName}</div>
              </div>
            </div>
            <div class="tooltip-status">
              <div class="status-badge ${
                project.active ? "tooltip-active" : "not-active"
              }">
              
              
              
              ${
                isHoursUnconfirmed(project.project_activities) &&
                project.completed
                  ? "Closed"
                  : project.drafted && !project.completed
                  ? "Draft"
                  : !project.completed && !project.drafted
                  ? "Active"
                  : "N/A"
              }</div>
            </div>
          </div>
        `;
      } else if (isActivity) {
        const activity = entityInfo.activity || {};
        console.log("entitt",entityInfo);
        const formattedDate = data.start
          ? moment(data.start).format("DD/MM/YYYY")
          : "";

        // Check if virtual visit and display appropriately
        const isVirtual = activity.virtual || false;
        let locationDisplay = "N/A";
        let locationIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 2a7 7 0 0 0-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 0 0-7-7Z"></path>
          <circle cx="12" cy="9" r="2"></circle>
        </svg>`;

        if (isVirtual) {
          locationDisplay = "Virtual";
          // Use video camera icon for virtual visits
          locationIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m22 8-6 4 6 4V8Z"></path>
            <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
          </svg>`;
        } else if (activity.location) {
          locationDisplay = activity.location;
        }

        return `
          <div class="custom-tooltip activity-tooltip">
            <div class="tooltip-date-header">
              <div class="calendar-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <div>${formattedDate}</div>
            </div>
             <div class="tooltip-row person-row ${
               !activity?.contractor && "missing-assigne"
             }">
          <div class="icon-container">
          ${activity?.contractor ?
                      `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>`
            :
            `<svg width="16" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M7.28884 7.29116C8.02684 7.29116 8.10157 7.1535 8.70655 7.49364C6.27616 7.49364 6.68124 9.84166 6.68124 12.1519C6.68124 13.0373 6.68124 13.7459 6.68124 14.5823H0.200195V11.6659C0.200195 9.31017 2.01038 7.38936 4.27804 7.29481L4.45337 7.29116H7.28884ZM5.87109 0C7.43709 0 8.70655 1.2695 8.70655 2.83546C8.70655 4.34922 7.52029 5.58594 6.02667 5.66671L5.87109 5.67089C4.30512 5.67089 3.03566 4.40139 3.03566 2.83546C3.03566 1.32168 4.22192 0.0849497 5.71554 0.00417725L5.87109 0Z" fill="#F2B705"/>
</svg>`} </div>
          <div class="tooltip-text">${
            activity?.contractor
              ? `${activity.contractor.user.given_name} ${activity.contractor.user.family_name}`
              : "Missing Assignee!"
          }</div>
        </div>
            <div class="tooltip-location">
              <div class="location-icon">
                ${locationIcon}
              </div>
              <div>
                ${locationDisplay}
              </div>
            </div>
          </div>
        `;
      } else {
        // Default tooltip for other items
        return `
          <div class="custom-tooltip">
            <div>${data.name || "Item"}</div>
            <div>${
              data.start ? new Date(data.start).toLocaleDateString() : ""
            } - ${data.end ? new Date(data.end).toLocaleDateString() : ""}</div>
          </div>
        `;
      }
    },
  },
  sorts: [{ field: "name", direction: "ASC" }],
  columns: [
    {
      type: "tree",
      text: "",
      field: "name",
      width: "20em",
      // Hide default tree icons
      expandedFolderIconCls: null,
      collapsedFolderIconCls: null,
      sortable: false,

      leafIconCls: null,
      cls: "b-first-column",
      // Set to `false` to render our custom markup
      htmlEncode: false,
      // Custom renderer display employee info or client color + name
      renderer(props) {
        const { record, value, size, parent, cellElement } = props;
        // Parent rows are employees

        const type = record.data.type;
        const data = record.data;
        if (type === "contractor" || type === "manager" || data.level === 1) {
          const isProject = type === "project";
          size.height = 74;
          const image = record.imageUrl
            ? StringHelper.xss`<div class="b-profile-img" style="background-image:url(${record.imageUrl})" ></div>`
            : "";
          // const image = record.image
          //   ? StringHelper.xss`<img class="b-profile-img" src="resources/images/${record.name.toLowerCase()}.jpg" />`
          //   : "";

          return `
                    <div class = "b-${type} b-vue-resource flex flex-row items-center content-center h-full leading-tight">
                      <div class="b-slide-bar" style="background-color:${
                        data.borderColor || data.color
                      }"></div>
                        <div class="b-left-section">
                          ${
                            !isProject
                              ? `<div class="b-avatar" style="background-color:${
                                  data.borderColor || data.color
                                }"> 
                             <span class="b-inital">${
                               image ? image : value?.slice(0, 2)
                             }</span> 
                          </div>`
                              : ""
                          }
                        </div>
                        <div class="b-right-section">
                         <div class="b-title"> ${
                           data.title
                         } ${renderMissingIcons(
            data.missingResource,
            data.missingManager
          )} </div>
                         <div class="b-subtitle">${
                           data.subtitle ? data.subtitle : ""
                         } </div>
                        </div>
                    </div>
                `;
        } else if (type === "activity") {
          size.height = 56;
          return `
          <div class="b-${type}">
            <span class="b-serial-no">
            ${data.index}
            </span>
            <span class="b-text flex items-center gap-1">
            ${value}  ${data.missingResource ? missingResourceTooltip(" ") : ""}

            </span>
          </div>`;
        } else if (type === "project") {
          size.height = 56;
          return `
          <div class="b-${type}">
            <span class="b-text">
            ${value}
            </span>
          </div>`;
        } else {
          return `
          <div class="b-${type}">
            ${value}
          </div>`;
        }
      },
    },
    {
      field: "progress",
      // headerRenderer: () => {
      //   return `<div class="b-progress-header">Progress <div data-btip="Progress relates to the designated start and end date of each task." >${infoSvg()}</div> </div>`;
      // },
      width: "10rem",
      htmlEncode: false,
      sortable: false,
      renderer: ({ record, value }) => {
        // Assuming `record.progress` holds a value between 0 and 100
        const type = record.data.type;
        const data = record.data;
        if (
          record.data.type === "contractor" ||
          record.data.type === "manager" ||
          record.data.level === 1
        ) {
          return `${
            data.noOfTotalTaks
              ? `

               <div class="b-${type}-tag w-full ">
               <div class='flex justify-end'>
               <div class="b-tag">${data.noOfTotalTaks} ${
                  data.noOfTotalTaks > 1 ? "visits" : "visit"
                }</div>
               </div>

          </div>
              `
              : ""
          } `;
        } else if (type === "activity") {
          // const prgoress = data.progress || 0;
          // const bgColor =
          //   prgoress <= 50
          //     ? "#FAC936"
          //     : prgoress >= 51 && prgoress < 80
          //     ? "#4adb84"
          //     : "#0DB952";
          // return `<div class="b-${type} b-progress-bar flex">
          //           <div class="bg-gray-200 rounded overflow-hidden" style="width:110px">
          //             <div  style="height:12px;width:${prgoress}%; background-color: ${bgColor};"></div>
          //           </div>
          //           <span class="b-label">${prgoress}%</span>
          //         </div>`;
          return "";
        } else if (type === "project") {
          return `
          <div class="b-${type}-tag">
            <div class="b-tag">${data.noOftasks} ${
            data.noOftasks === 1 ? "visit" : "visits"
          }</div>
            <div class="b-icon-holder b-add-activity">
             ${plusSvg()}
            </div>
          </div>
    `;
        }
        return value;
      },
    },
  ],
  eventRenderer({ eventRecord, resourceRecord, renderData }) {
    // You can also directly set styles
    renderData.style += `background-color: ${resourceRecord.data.color};`; // Assuming 'color' is a field with a valid CSS color value

    return eventRecord.name; // Return the content of the event bar, usually the event name
  },
};

export { schedulerConfig };
